module.exports = __webpack_public_path__ + "img/47.32593c8.png";